<template>
  <div>
    <nav-bar></nav-bar>
    <connection-answer v-if="showConnectionAnswer" v-on:closeConnectionView="closeConnectionView" :answer="answer"></connection-answer>
    <div class="container intents">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/clients')">{{ CONSTANTS.getCopy('UPDATEANSWER_BREADCRUMB_CHATBOTS') }}</a></li>
            <li><a @click="$router.push('/clients/'+client+'/intents')">{{clientName}}</a></li>
            <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences')">{{intentName}}</a></li>
            <li v-if="typeAnswer === 0"><a @click="$router.push('/clients/' + client + '/intents/' + intent + '/sentences/' + sentence + '/answers')">{{ sentenceName }}</a></li>
            <li v-if="typeAnswer === 0"><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences/' + sentence + '/answers')">{{ CONSTANTS.getCopy('UPDATEANSWER_BREADCRUMB_ANSWERS') }}</a></li>
            <li v-if="typeAnswer === 1"><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences?tab=common-answers')">{{ CONSTANTS.getCopy('UPDATEANSWER_BREADCRUMB_COMMON_ANSWERS') }}</a></li>
            <li v-if="typeAnswer === 2"><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences?tab=default-answers')">{{ CONSTANTS.getCopy('UPDATEANSWER_BREADCRUMB_DOUBT_ANSWERS') }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('UPDATEANSWER_BREADCRUMB_UPDATE_ANSWER') }} {{typeAnswer !== 0 ? (typeAnswer === 1 ? 'comunes' : 'de duda') : ''}}</a></li>
          </ul>
        </nav>
        <div class="is-flex-row-center">
          <!-- TABS -->
          <div class="tabs is-toggle">
            <ul>
              <li v-if="typeResponse === 1" class="is-active">
                <a><span>{{ CONSTANTS.getCopy('UPDATEANSWER_TABS_SIMPLE') }}</span></a>
              </li>
              <li v-if="typeResponse === 2" class="is-active">
                <a><span>{{ CONSTANTS.getCopy('UPDATEANSWER_TABS_COMPLEX') }}</span></a>
              </li>
            </ul>
          </div>
          <a class="connection" v-if="typeResponse === 2" @click="toggleConnectionAnswer">{{ CONSTANTS.getCopy('UPDATEANSWER_SET_UP_CONN') }}</a>
        </div>
        <div class="columns">
          <!-- Response section -->
          <div class="column pr-2">
            <div class="field">
              <label class="label">{{ CONSTANTS.getCopy('UPDATEANSWER_RESPONSE_SECTION_LABEL') }}</label>
              <div v-for="(response, index) in responses" :key="index" class="control">
                <div v-if="response['type'] === 'text'">
                  <textarea v-model="responses[index]['response']" class="is-full-width" :id="`response${index}`"
                            v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_RESPONSES_WRITE_PLACEHOLDER') " @click="boxFocus = index" @focus="sentencePosition = 0"
                    :class="{'input-error': showTextBoxError && !responses[index]['response']}">
                  </textarea>
                  <span class="icon close-box" @click="deleteResponse(index)"><i class="fas fa-times"></i></span>
                </div>
                <div v-else class="is-flex-row-center space-between file-box">
                  <div>
                    <span class="icon"><i class="fas fa-file-alt"></i></span>{{ formatFilePayload(response['response']) }}
                  </div>
                  <span class="icon cpointer" @click="deleteResponse(index)"><i class="fas fa-times"></i></span>
                </div>
              </div>
            </div>
            <div v-if="isLanguagePickerShown" class="field">
              <div class="control">
                <div class="select is-medium">
                  <select v-model="answer.languageId" :class="{'input-error': showLanguagePickerError}" @change="showLanguagePickerError = false">
                    <option v-for="language in languages" :key="language.idLanguage" :value="language.idLanguage">
                      {{language.language}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="showFileSection" class="is-flex-row-center file-section">
              <div class="select">
                <select v-model="filePayload" @change="addFilePayload">
                  <option v-for="(payload, index) in filePayloads" :value="payload" :key="index">{{ payload }}</option>
                </select>
              </div>
              <div class="button is-primary" @click="showAddFile">{{ CONSTANTS.getCopy('UPDATEANSWER_BUTTON_ADD_FILE') }}</div>
            </div>
            <div class="is-flex-row-center buttons">
              <div class="button" :class="{'is-primary': showEmojis}" @click="showEmojis = !showEmojis">{{ CONSTANTS.getCopy('UPDATEANSWER_BUTTON_SHOW_EMOJI') }}</div>
              <div class="button" @click="addResponse">+</div>
              <div class="button" :class="{'is-primary': showFileSection}" @click="showFileSection = !showFileSection">{{ CONSTANTS.getCopy('UPDATEANSWER_BUTTON_SHOW_EMOJI_FILE') }}</div>
            </div>
            <emojis v-if="showEmojis" @emoji-selected="addElement"></emojis>
          </div>
          <!-- Dialog and next intent section -->
          <div class="column">
            <label class="label"><input type="radio" name="option" @click="optionSelected = 1" ref="guidedDialog"/> {{ CONSTANTS.getCopy('UPDATEANSWER_GUIDED_DIALOG_LABEL') }}</label>
            <form v-if="optionSelected === 1" class="is-flex-column-center">
              <label class="is-warning" v-if="showWarningLengthButton"><span class="icon"><i class="fas fa-exclamation-triangle"></i></span>{{ CONSTANTS.getCopy('UPDATEANSWER_WARNING_LENGTH_ERROR') }}</label>
              <label class="is-error" v-if="showLowLineError"><span class="icon"><i class="fas fa-exclamation-circle"></i></span>{{ CONSTANTS.getCopy('UPDATEANSWER_LOW_LINE_ERROR') }}</label>
              <label class="cb-dialog"><input type="checkbox" name="dialog" v-model="dialogSelected[0]" /> {{ CONSTANTS.getCopy('UPDATEANSWER_NAVIGATION_BUTTONS') }}</label>
              <div v-if="dialogSelected[0]">
                <div v-if="isAdmin" class="is-flex-row-justify-end">
                  <label>{{ CONSTANTS.getCopy('UPDATEANSWER_MULTISELECT') }}</label>
                  <span v-if="answer.multiselect" class="icon is-success" @click="answer.multiselect = 0">
                    <i class="fas fa-toggle-on"></i>
                  </span>
                  <span v-else class="icon is-warning" @click="answer.multiselect = 1">
                    <i class="fas fa-toggle-off"></i>
                  </span>
                </div>
                <div v-for="(button, index) in buttonsNavigation" :key="index" class="dialog-inputs nav">
                  <input type="text" :class="{'input-error': !buttonsNavigation[index][0] && buttonsNavigation[index][1] || buttonsNavigation[index][0] && lowLineRegExp.test(buttonsNavigation[index][0]) }"
                         v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_INPUT_PAYLOAD_PLACEHOLDER') "
                    v-model="buttonsNavigation[index][0]" @keyup="checkInputs"/>
                  <input type="text" :class="{'input-warning': buttonsNavigation[index][1] && buttonsNavigation[index][1].length > 20 , 'input-error': (!buttonsNavigation[index][1] && buttonsNavigation[index][0])}"
                         v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_INPUT_BUTTON_TEXT_PLACEHOLDER') "
                    v-model="buttonsNavigation[index][1]" @keyup="checkInputs"/>
                  <input type="text" :class="{'input-error': buttonsNavigation[index][2] && lowLineRegExp.test(buttonsNavigation[index][2]) }"
                         v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_INPUT_KEYWORDS_PLACEHOLDER') " v-model="buttonsNavigation[index][2]" @keyup="checkInputs"/>
                </div>
              </div>
              <label class="cb-dialog"><input type="checkbox" ref="free-text" name="dialog" v-model="dialogSelected[1]"/>{{ CONSTANTS.getCopy('UPDATEANSWER_INPUT_FREE_TEXT_LABEL') }}</label>
              <div v-if="dialogSelected[1]">
                <div class="dialog-inputs free-text">
                  <input type="text" :class="{'input-error': (freeTextValues[1] && !freeTextValues[0]) || freeTextValues[0] && lowLineRegExp.test(freeTextValues[0])}"
                         v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_FREE_TEXT_INPUT_PAYLOAD_DIALOG_SELECTED1') " v-model="freeTextValues[0]" @keyup="checkInputs"/>
                  <input type="text" :class="{'input-error': (freeTextValues[0] && !freeTextValues[1]) ||freeTextValues[1] && lowLineRegExp.test(freeTextValues[1])}"
                         v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_FREE_TEXT_INPUT_PARAM_NAME_SELECTED1') " v-model="freeTextValues[1]" @keyup="checkInputs"/>
                </div>
              </div>
            </form>
            <label class="label"><input type="radio" name="option" @click="optionSelected = 2" ref="nextIntent"/> {{ CONSTANTS.getCopy('UPDATEANSWER_INPUT_FORCE_NEXT_INT_LABEL') }}</label>
            <div v-if="optionSelected === 2">
              <label class="is-error" v-if="showLowLineError"><span class="icon"><i class="fas fa-exclamation-circle"></i></span>{{ CONSTANTS.getCopy('UPDATEANSWER_LOW_LINE_ERROR_SELECTED2') }}</label>
              <div class="dialog-inputs">
                <input type="text" :class="{'input-error': nextIntentValue && lowLineRegExp.test(nextIntentValue)}" v-bind:placeholder="CONSTANTS.getCopy('UPDATEANSWER_PAYLOAD_DIALOG_PLACEHOLDER') "
                       v-model="nextIntentValue" @keyup="checkInputs"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!showConnectionAnswer" class="is-right-bottom">
          <div class="button is-primary" @click="updateAnswer">
            <span class="icon"><i class="fas fa-save fa-lg"></i></span>
            <span class="is-capitalized">{{ CONSTANTS.getCopy('UPDATEANSWER_SAVE_BUTTON') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Emojis from '../../../templates/Emojis'
import Strings from '../../../../lib/Strings'
import ConnectionAnswer from './ConnectionAnswer'
import Answers from '../../../../lib/AnswersMethods'
import AnswerTypes from '../../../../lib/AnswerTypes'
import Auth from '../../../../models/auth'

export default {
  components: { ConnectionAnswer, Emojis },
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intent: this.$route.params.intent,
      intentName: 'Intención',
      sentence: null,
      sentenceName: 'Frase',
      answerId: this.$route.params.answer,
      responses: [],
      answer: {},
      typeResponse: 1,
      optionSelected: null,
      dialogSelected: new Array(2),
      boxFocus: 0,
      fileName: null,
      showConnectionAnswer: false,
      showTextBoxError: false,
      showWarningLengthButton: false,
      showLowLineError: false,
      showEmojis: false,
      buttonsNavigation: [],
      freeTextValues: new Array(2),
      nextIntentValue: null,
      fileRegExp: /\{DOC_\w+\}/gi,
      lowLineRegExp: /_/,
      filePayloads: null,
      showFileSection: false,
      typeAnswer: 0,
      isLanguagePickerShown: false,
      showLanguagePickerError: false,
      languages: []
    }
  },
  computed: {
    userName () {
      return localStorage.getObject('user.name', false)
    },
    isAdmin () {
      return Auth.isAdmin()
    }
  },
  created () {
    this.typeAnswer = this.$route.meta.typeAnswer
    this.isLanguagePickerShown = this.typeAnswer !== 0
    this.isLanguagePickerShown && this.getLanguages()
    this.getAnswer()
    this.breadcrumbDetails()
  },
  methods: {
    getAnswer () {
      this.api.post('/ResponseById', {idResponse: this.answerId}).then(response => {
        this.answer = response.response
        if (this.answer.parametersList) {
          this.answer.parametersList = Strings.decodeProcessParameters(this.answer.parametersList)
        }
        if (this.answer.process) {
          this.typeResponse = 2
        }
        this.getButtons()
        this.getFreeText()
        this.getNextIntent()
        this.separateResponse()
        this.setResponseTypes()
        this.getFilePayloads()
        this.checkInputs()
      })
    },
    breadcrumbDetails () {
      this.api.post('/ClientById/', {idClient: this.client}).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', {idIntent: this.$route.params.intent}).then(response => {
        this.intentName = response.intent.name
      })
      if (this.typeAnswer === AnswerTypes.SENTENCE) {
        this.sentence = this.$route.params.sentence
        this.api.post('/PhraseById', { idDictionary: this.sentence }).then(response => {
          this.sentenceName = response.phrase.term
        })
      }
    },
    getLanguages () {
      this.api.post('/DataLanguageList').then(response => {
        this.languages = response.languages
      })
    },
    separateResponse () {
      this.responses = this.answer.response.split('[SALTO_MENSAJE]')
    },
    setResponseTypes () {
      let responsesTemp = []
      this.responses.forEach((element) => {
        let type = this.fileRegExp.test(element) ? 'file' : 'text'
        this.fileRegExp.test(element)
        responsesTemp.push({response: element, type: type})
      })
      this.responses = responsesTemp
    },
    getButtons () {
      let buttonsRegExp = /\[BUTTON_.[^\]]+\]/gi
      let buttonsArray = this.answer.response.match(buttonsRegExp)
      if (buttonsArray !== null) {
        this.optionSelected = 1
        this.dialogSelected[0] = true
        this.$refs.guidedDialog.checked = true
        this.answer.response = this.answer.response.replace(buttonsRegExp, '')
        buttonsArray.forEach((element, index) => {
          let inputs = element.split('_')
          if (inputs.length === 3) {
            this.buttonsNavigation[index] = [inputs[1], inputs[2].split(']')[0]]
            return
          }
          this.buttonsNavigation[index] = [inputs[1], inputs[2], inputs[3].split(']')[0]]
        })
        for (let i = this.buttonsNavigation.length; i < 9; i++) {
          this.buttonsNavigation[i] = new Array(3)
        }
        return
      }
      this.buttonsNavigation = new Array(9)
      for (let i = 0; i < this.buttonsNavigation.length; i++) {
        this.buttonsNavigation[i] = new Array(3)
      }
    },
    getFreeText () {
      let freeTextRegExp = /\[TEXTOLIBRE_[\w+|-]*]/gi
      let freeTextArray = this.answer.response.match(freeTextRegExp)
      if (freeTextArray !== null) {
        this.optionSelected = 1
        this.dialogSelected[1] = true
        this.answer.response = this.answer.response.replace(freeTextRegExp, '')
        let inputs = freeTextArray[0].split('_')
        this.freeTextValues[0] = inputs[1]
        this.freeTextValues[1] = inputs[2].split(']')[0]
      }
    },
    checkInputs () {
      this.showWarningLengthButton = false
      this.showLowLineError = false
      if (this.optionSelected === 1) {
        this.buttonsNavigation.forEach((element) => {
          if (element[1] && element[1].length > 20) this.showWarningLengthButton = true
          if (element && (this.lowLineRegExp.test(element[0]) || this.lowLineRegExp.test(element[1]) || this.lowLineRegExp.test(element[2]))) this.showLowLineError = true
        })
        if (this.lowLineRegExp.test(this.freeTextValues[0]) || this.lowLineRegExp.test(this.freeTextValues[1])) this.showLowLineError = true
      }
      if (this.optionSelected === 2 && this.lowLineRegExp.test(this.nextIntentValue)) this.showLowLineError = true
      this.$forceUpdate()
    },
    getNextIntent () {
      let nextIntentRegExp = /\[INTENCION_(\w|\s)*\]/gi
      let nextIntentArray = this.answer.response.match(nextIntentRegExp)
      if (nextIntentArray !== null) {
        this.optionSelected = 2
        this.$refs.nextIntent.checked = true
        this.answer.response = this.answer.response.replace(nextIntentRegExp, '')
        this.nextIntentValue = nextIntentArray[0].split('_')[1]
        this.nextIntentValue = this.nextIntentValue.split(']')[0]
      }
    },
    showAddFile () {
      this.dialog.uploadAnswerFile({typeAnswer: this.answer.type}).then(() => {
        this.getFilePayloads()
      })
    },
    getFilePayloads () {
      this.api.post('/ResponsesFilePayloadList', {idClient: this.client}).then((response) => {
        this.filePayloads = response.payloads
      })
    },
    addFilePayload () {
      this.responses.push({response: `{DOC_${this.filePayload}}`, type: 'file'})
    },
    addButtonsResponse (syntax) {
      let counter = this.responses.length - 1
      let carryOn = true
      while (carryOn) {
        if (this.responses[counter].type === 'text') {
          this.responses[counter].response += syntax
          carryOn = false
        }
        counter--
      }
    },
    setButtons () {
      this.buttonsNavigation.forEach((element) => {
        if (element[0] !== undefined && element[0].length > 0) {
          if (element.length === 3 && element[2] !== undefined && element[2].length > 0) {
            this.addButtonsResponse(`[BUTTON_${element[0]}_${element[1]}_${element[2]}]`)
            return
          }
          this.addButtonsResponse(`[BUTTON_${element[0]}_${element[1]}]`)
        }
      })
    },
    setFreeText () {
      if (this.freeTextValues[0] !== undefined && this.freeTextValues[0].length > 0 && this.freeTextValues[1].length > 0) {
        this.answer.response += `[TEXTOLIBRE_${this.freeTextValues[0]}_${this.freeTextValues[1]}]`
        return
      }
      this.cleanResponseForFreeText()
    },
    closeConnectionView () {
      this.showConnectionAnswer = false
    },
    addResponse () {
      this.responses.push({response: '', type: 'text'})
    },
    deleteResponse (index) {
      this.responses.splice(index, 1)
    },
    formatFilePayload (response) {
      let payload = response.split('{DOC_')[1]
      return payload.split('}')[0]
    },
    addElement (syntax) {
      let data = Answers.addElement(syntax, this.responses[this.boxFocus].response, this.sentencePosition, `#response${this.boxFocus}`)
      this.responses[this.boxFocus].response = data.sentence
      this.sentencePosition = data.position
      this.$forceUpdate()
    },
    toggleConnectionAnswer () {
      this.showConnectionAnswer = !this.showConnectionAnswer
      this.showEmojis = false
    },
    cleanResponseForFreeText () {
      this.answer.response = this.answer.response.replace(/\[TEXTOLIBRE__]/g, '')
    },
    updateAnswer () {
      this.showTextBoxError = false
      let save = true
      let existsBoxWithText = false

      if (this.optionSelected === 1) {
        this.buttonsNavigation.forEach((element) => {
          if ((element[0] && !element[1]) || (!element[0] && element[1])) save = false
        })
        if ((this.freeTextValues[0] && !this.freeTextValues[1]) || (!this.freeTextValues[0] && this.freeTextValues[1])) save = false
      }
      if (!save || this.showLowLineError) return

      this.responses.forEach((element) => {
        if (element.type === 'text' && element.response && element.response.length > 0) {
          existsBoxWithText = true
        }
      })
      if (!existsBoxWithText) {
        let existsBoxText = this.responses.filter((element) => element.type === 'text')
        if (!existsBoxText.length > 0) this.responses.push({response: null, type: 'text'})
        this.showTextBoxError = true
        return
      }
      if (this.optionSelected === 1) this.setButtons()
      this.answer.response = this.responses.map((element) => element['response']).join('[SALTO_MENSAJE]')
      this.cleanResponseForFreeText()
      if (this.optionSelected === 1 && this.$refs['free-text'].checked) this.setFreeText()
      if (this.nextIntentValue && this.optionSelected === 2) this.answer.response += `[INTENCION_${this.nextIntentValue}]`

      if (this.isLanguagePickerShown) {
        if (this.answer.languageId === -1) {
          this.showLanguagePickerError = true
          return
        }
      }

      let endpoint = '/ResponseUpdate'
      if (this.typeResponse === 2) endpoint = '/ResponseUpdateProcess'

      let parametersList = {}

      if (this.answer.parametersList) {
        parametersList = Strings.encodeProcessParameters(this.answer.parametersList, this.answerId)
      }

      this.api['post'](endpoint, {...this.answer, parametersList}).then(() => {
        if (this.typeAnswer === AnswerTypes.COMMON) localStorage.setItem('answerView', 'common-answers')
        if (this.typeAnswer === AnswerTypes.DEFAULT) localStorage.setItem('answerView', 'default-answers')
        this.$router.go(-1)
      })
    }
  }
}
</script>
<style scoped>
  .tabs.is-toggle li.is-active a {
    border-radius: var(--general-border-radius) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/commonAndDefaultAnswers/UpdateAnswer.vue